import { render, staticRenderFns } from "./PriceConfig.vue?vue&type=template&id=601d63e4&"
import script from "./PriceConfig.vue?vue&type=script&lang=js&"
export * from "./PriceConfig.vue?vue&type=script&lang=js&"
import style0 from "./PriceConfig.vue?vue&type=style&index=0&id=601d63e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports